import { render, staticRenderFns } from "./Perfil.vue?vue&type=template&id=5b2a1165&scoped=true&"
import script from "./Perfil.vue?vue&type=script&lang=ts&"
export * from "./Perfil.vue?vue&type=script&lang=ts&"
import style0 from "./Perfil.vue?vue&type=style&index=0&id=5b2a1165&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2a1165",
  null
  
)

export default component.exports